/**
 * Created by nijin on 21/12/16.
 */
import {Component, OnInit, Input} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {WizardBaseContentComponent} from "../shared/wizard/wiz-base.component";
import {ThingsService} from "../things.service";
import {Observable, Subject} from "rxjs";
import {GlobalValidator} from "../../shared/validators/global-validator";

@Component({
  selector: 'nuc-describe-thing',
  templateUrl: './describe-thing.component.html',
  styles:[`.input-group{
		margin-bottom: 25px;
	}
  textarea{
    height: 60px;
    }
    .input-group, .form-group {
      margin-bottom: 35px;
    }
    .describeFormContainer{
      padding: 20px 15px;
    }
  .addTags{
    position: relative;
    }
  .addTags .keywords{
    margin: 10px 0px;
    }
  .addTags .dropdown-menu{
    width: 100%;
    margin: 0;
    top: 42px;
    }
    .addTags.open .dropdown-menu{
      display: block;
    }
  .addTags .dropdown-menu > li > a{
    padding: 5px 20px;
    color: #a1a1a1;
    font-size: 15px;
    transition: .3s all;
    }
  .addTags .dropdown-menu > li > a:hover, .addTags .dropdown-menu > li > a:focus{
    color: #265390;
    background-color: rgb(237, 237, 237);
    }
    `]
})
export class DescribeThingComponent extends WizardBaseContentComponent implements OnInit {
  @Input() order ;
  form: FormGroup;
  isSubmitted = false;
  tagSuggestions: Observable<any[]>;
   searchTermStream = new Subject<string>();
   isUniqueThingName = false;
  @Input() isMobileApp = false;
  thing = {};
  tags = [];
  formErrors = {
    'name': '',
    'description': '',
    'tags': ''
  };
  validationMessages = {
    'name': {
      'required': 'ONBOARD_THING.VALIDATIONS.DESCRIBE_THING.NAME.REQUIRED',
      'maxlength': 'ONBOARD_THING.VALIDATIONS.DESCRIBE_THING.NAME.MAX_LENGTH',
      'consecutiveSpace': 'CMN_VALIDATIONS.CONSECUTIVE_SPACE',
      'minlength': 'CMN_VALIDATIONS.MIN_LENGTH_TWO'
    },
    'description': {
      'maxlength': 'ONBOARD_THING.VALIDATIONS.DESCRIBE_THING.DESCRIPTION.MAX_LENGTH'
    },
    'tags':{
      'consecutiveSpace': 'CMN_VALIDATIONS.CHARACTER_OTHERTHAN_SPACE',
      'maxlength': 'ONBOARD_THING.VALIDATIONS.DESCRIBE_THING.TAGS.MAX_LENGTH'
    }

  };
  constructor(
    private  thingService: ThingsService,
    private  fb: FormBuilder,
  ) {
    super();
  }

  ngOnInit() {
    this.buildForm();
    this.tagSuggestions = this.searchTermStream
      .debounceTime(400)
      .distinctUntilChanged()
      .switchMap((term: string)  => this.thingService.getTags(term) );
  }

  canMoveForward() {
    return this.form.valid;
  }
  search(term: string) {
    this.searchTermStream.next(term);
  }


  onInvalidState() {
    this.isSubmitted = true;
    this.onValueChanged();
  }

  onValidState(subject, nextStep) {
    this.thingService.setThingBasicInfo(this.form.value, this.tags);
    subject.next(nextStep);
  }

  removeTag(tag) {
    let idx = this.tags.indexOf(tag);
    this.tags.splice(idx, 1);
  }

  buildForm() {
    this.form = this.fb.group({
      'name': ['', [
        Validators.required,
        Validators.maxLength(50),
        GlobalValidator.consecutiveSpace,
        Validators.minLength(2)
      ]
      ],
      'description': ['', [
        Validators.maxLength(250)
      ]
      ],
      'tags': ['', [
        Validators.maxLength(50)
      ]
      ],

    })
    this.form.valueChanges
      .subscribe(data => this.onValueChanged(data));
    this.onValueChanged();
  }
  addTag(tag) {
    this.formErrors.tags = '';
    let t = tag;
    if (!t.replace(/\s/g, '').length) {
      this.formErrors.tags = 'CMN_VALIDATIONS.CONSECUTIVE_SPACE'
      return;
    }
    if (tag.length > 50) {
      this.formErrors.tags = 'ONBOARD_THING.VALIDATIONS.DESCRIBE_THING.TAGS.MAX_LENGTH';
      return;
    }


    if (this.tags.indexOf(tag.trim()) > -1)
      return;
    this.tags.push(tag.trim());
    this.form.controls['tags'].reset('');
    this.thingService.addTag(tag.trim())
      .subscribe(() => { });
  }


  onValueChanged(data?: any) {
    const form = this.form;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && (control.dirty && !control.valid || this.isSubmitted)) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] = messages[key];
        }
      }

    }
  }


  preview() {}


}



// WEBPACK FOOTER //
// ./src/app/things/onboard/describe-thing.component.ts